/**
 * Native Date relative-time formatter (vi-VN). Tiny — avoids adding date-fns.
 */
export const formatRelative = (input) => {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "-";

  const diffMs = Date.now() - d.getTime();
  const future = diffMs < 0;
  const abs = Math.abs(diffMs);
  const sec = Math.round(abs / 1000);
  if (sec < 60) return future ? `trong ${sec}s` : `vừa xong`;
  const min = Math.round(sec / 60);
  if (min < 60) return future ? `sau ${min} phút` : `${min} phút trước`;
  const hour = Math.round(min / 60);
  if (hour < 24) return future ? `sau ${hour} giờ` : `${hour} giờ trước`;
  const day = Math.round(hour / 24);
  if (day < 7) return future ? `sau ${day} ngày` : `${day} ngày trước`;
  return d.toLocaleDateString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const formatDateTime = (input) => {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTimeOnly = (input) => {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleTimeString("vi-VN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

/** "HH:mm:ss" for timeline rows when same day, else full date+time. */
export const formatTimelineStamp = (input, refDate = new Date()) => {
  if (!input) return "-";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "-";
  const sameDay =
    d.getFullYear() === refDate.getFullYear() &&
    d.getMonth() === refDate.getMonth() &&
    d.getDate() === refDate.getDate();
  if (sameDay) return formatTimeOnly(d);
  return formatDateTime(d);
};
